// Google Analytics 4 helpers + fallback in-house pageview counter.
// GA is loaded via /public/index.html (gtag.js). We wrap it here to keep call
// sites tidy and to also mirror events to our own /api/analytics/* endpoints
// so the admin visitor-counter card stays accurate even when GA is blocked.
import api from "@/lib/api";

export const GA_MEASUREMENT_ID = "G-QDB6NWPPG9";

function gtagSafe() {
  return typeof window !== "undefined" && typeof window.gtag === "function" ? window.gtag : null;
}

export function trackPageview(path) {
  const gtag = gtagSafe();
  if (gtag) {
    gtag("config", GA_MEASUREMENT_ID, { page_path: path });
  }
  // Fire-and-forget in-house counter — never blocks or throws
  try {
    api.post("/analytics/pageview", { path }).catch(() => {});
  } catch (_) { /* ignore */ }
}

export function trackEvent(name, params = {}) {
  const gtag = gtagSafe();
  if (gtag) {
    gtag("event", name, params);
  }
  try {
    api.post("/analytics/event", { name, params }).catch(() => {});
  } catch (_) { /* ignore */ }
}

// Convenience shortcuts for the events the admin cares about
export const trackApplyNow = (jobId, category) => trackEvent("apply_now_click", { job_id: jobId, category });
export const trackLogin = (method) => trackEvent("login", { method });   // method: "email" | "otp"
export const trackRegister = (role) => trackEvent("sign_up", { role });
export const trackJobPost = (category, isPremium) => trackEvent("job_post", { category, premium: !!isPremium });
export const trackPaymentSuccess = (pkg, amount) => trackEvent("payment_success", { package: pkg, value: amount, currency: "INR" });
export const trackVoiceUsed = (lang) => trackEvent("voice_assistant_open", { language: lang });
